<template>
  <div class="babybooktimeset">
    <div :style="{position: 'relative'}">
      <div class="eventinfo">
        <div class="title"><span>活動資訊</span> <button class="editBtn" @click="editBasic=!editBasic" v-if="!editBasic"></button></div>
        <inputField label="活動上線">
          <div :style="{display: 'flex', alignItems:'center', justifyContent: 'flex-start', gap: '10px'}">
            <input :disabled="!editBasic" type="radio" v-model.trim="babyActivity" :value="true" label="開放活動">
            <input :disabled="!editBasic" type="radio" v-model.trim="babyActivity" :value="false" label="關閉活動">
          </div>
        </inputField>
        <inputField label="活動時間"><vue-ctk-date-time-picker :disabled="!editBasic" :range="true" v-model="range"
          :color="'var(--color-pri)'"
          :no-label="true"
          :input-size="'sm'"
          :label="'選取時間範圍'"
          :format="'YYYY-MM-DD'"
          :formatted="'YYYY-MM-DD'"
          id="daterange"
          @input="setDate()"/></inputField>
        <confirmBtns v-if="editBasic" @cancel="cancel" :style="{alignSelf: 'flex-end'}" @confirm="saveBasic"/>
      </div>
      <editCube13 title="預約日範圍設定"/>
      <div>
        <div class="title">預約時段設定</div>
        <editCubeDate title="平日" :keyname2="'babyBookableWeekday'" :keyname="'babyTimeWeekday'"
          @update2="update('babyBookableWeekday', $event)"
          @update="update('babyTimeWeekday', $event)"/>
        <editCubeDate title="假日" :keyname2="'babyBookableHoliday'" :keyname="'babyTimeHoliday'"
          @update2="update('babyBookableHoliday', $event)"
          @update="update('babyTimeHoliday', $event)"/>
      </div>
      <editCube9 title="活動人數預約上限"/>
    </div>
    <div>
      <editCube title="付訂成功說明" keyname="babySuccessPaid1"/>
      <editCube title="狀態查詢" keyname="babySuccessPaid2"/>
      <editCube title="預約成功-底層備註" keyname="babySuccessFooterDesc"/>
    </div>
    <div>
      <editCubeRT title="報到須知及入園規範" keyname="babyCheckInDesc"/>
      <!-- <editCube title="付訂成功說明(一)" keyname="babySuccessPaid1"/>
      <editCube title="付訂成功說明(二)" keyname="babySuccessPaid2"/> -->
    </div>
  </div>
</template>

<script>
import editCubeRT from '../../components/editCubeRichText.vue'
import editCube from '../../components/editCube.vue'
import confirmBtns from '../../components/confirmBtns.vue'
import inputField from '../../components/inputField.vue'
import editCube9 from '../../components/editCube9.vue'
import editCube13 from '../../components/editCube13.vue'
import editCubeDate from '../../components/editCube8.vue'
import { getapi, postapi } from '../../store/fetch'
export default {
  name: 'babybooktimeset',
  components: {
    editCubeRT,
    editCube,
    editCube9,
    editCube13,
    editCubeDate,
    inputField,
    confirmBtns
  },
  data () {
    return {
      editBasic: false,
      babyActivity: false,
      range: {
        start: this.moment().startOf('year').format('yyyy-MM-DD'),
        end: this.moment().endOf('year').format('yyyy-MM-DD')
      },
      masks: {
        weekdays: 'WWW'
      },
      cenlendar: {
        month: this.moment().month(),
        year: this.moment().year()
      },
      attributes: [
      ],
      holidays: [],
      bookstatus: [],
      selected: null,
      babyTimeHoliday: [],
      babyTimeWeekday: [],
      babyBookableWeekday: false,
      babyBookableHoliday: false,
      babyStatus: [],
      itemSelect: null
    }
  },
  watch: {
  },
  computed: {
  },
  async mounted () {
    this.babyTimeWeekday = await getapi('selections/babyTimeWeekday')
    this.babyTimeHoliday = await getapi('selections/babyTimeHoliday')
    this.babyBookableWeekday = await getapi('selections/babyBookableWeekday')
    this.babyBookableHoliday = await getapi('selections/babyBookableHoliday')
    this.babyStatus = await getapi('babyStatus')
    this.babyActivity = await getapi('selections/babyActivity')
    const range = await getapi('selections/babyDateRange')
    this.range = {
      start: this.toDate(range.start),
      end: this.toDate(range.end)
    }

    this.getHoliday()
  },
  methods: {
    async saveBasic () {
      await postapi('selections/babyActivity', {
        key: 'bool',
        data: this.babyActivity
      })
      await postapi('selections/babyDateRange', {
        key: 'obj',
        data: {
          start: this.moment(this.range.start).startOf('day').toISOString(),
          end: this.moment(this.range.end).endOf('day').toISOString()
        }
      })
      this.babyActivity = await getapi('selections/babyActivity')
      const range = await getapi('selections/babyDateRange')
      this.range = {
        start: this.toDate(range.start),
        end: this.toDate(range.end)
      }
      this.editBasic = false
    },
    async cancel () {
      this.babyActivity = await getapi('selections/babyActivity')
      const range = await getapi('selections/babyDateRange')
      this.range = {
        start: this.toDate(range.start),
        end: this.toDate(range.end)
      }
      this.editBasic = false
    },
    async updateItemSelect () {
      const data = this.bookstatus.find(e => this.toDate(e._id) === this.selected)
      const isHoliday = this.holidays.includes(this.toDate(this.selected))
      const wd = this.moment(this.selected).weekday()
      const isWeekend = wd === 0 || wd === 6 || wd === 7
      const options = (isHoliday || isWeekend) ? this.babyTimeHoliday : this.babyTimeWeekday
      const closed = this.babyStatus.find(e => this.toDate(e.date) === this.selected)
      this.itemSelect = {
        isHoliday: isHoliday || isWeekend,
        options: options.map(e => {
          return {
            time: e,
            closed: closed ? closed.closed.includes(e) : false
          }
        }),
        disabled: closed && closed.disabled ? closed.disabled : false,
        data: data
      }
    },
    async getAvailables () {
      // console.log({
      //   date: this.selected,
      //   isHoliday: this.itemSelect.isHoliday
      // })
    },
    update (k, e) {
      this[k] = e
    },
    async getHoliday () {
      const holidays = await getapi('holidays')
      this.holidays = holidays.map(e => this.moment(e.date).format('YYYY-MM-DD'))
      // console.log(this.holidays.includes('2022-05-02'))
    }
  }

}
</script>

<style lang="scss">
.babybooktimeset {
  .editCube p {
    min-height: 60px;
  }
  .parents {
    width: 100%;
    text-align: center;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    &:nth-child(odd) {
      background-color: var(--color-infobox);
      color: var(--color-pri);
    }
    &:nth-child(even) {
      background-color: var(--color-checked);
      color: #FFFFFF;
    }
  }
  .eventinfo {
    margin-bottom: 40px;
    &>div:nth-child(1) {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 25px;
      letter-spacing: 0.1em;
      color: var(--color-checked);
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      &>button {
        width: 38px;
        height: 38px;
        background-color: var(--color-checked);
        border: none;
        border-radius: 50%;
        margin-left: auto;
        background-image: url(/pen.svg);
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }
  #daterange-wrapper {
    width: 300px;
  }
  .inputfield {
    .date-time-picker .field::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 36px;
      height: 36px;
      -webkit-mask-size: contain;
      mask-size: contain;
      background-color: var(--color-checked);
      -webkit-mask-size: 22px;
      mask-size: 22px;
      -webkit-mask-image: url(/calendar2.svg);
      mask-image: url(/calendar2.svg);
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-position: center;
      mask-position: center;
    }
    .date-time-picker {
      margin-inline: 0;
    }
    .date-time-picker .align-center {
    }
    input[type=text] {
      text-align: start;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 18px!important;
      color: var(--color-letter);
      width: 320px;
      padding-inline: 14px;
    }
    height: 60px;
    input[type=radio] {
      appearance: none;
      background-color: #C4C4C4;
      min-width: 125px;
      width: fit-content;
      height: 40px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      text-align: center;
      letter-spacing: 0.1em;
      &:checked {
        background-color: var(--color-checked);
      }
      &::after {
        content: attr(label);
      }
    }
  }
}
.full {
  width: 42px;
  height: 42px;
  background: var(--color-confirm);
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-inline: auto;
  margin-top: 25px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
}
.gridin {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  align-items: center;
  justify-content: center;
  &>div {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &>:nth-child(1){background-color: var(--color-infobox);}
  &>:nth-child(4){background-color: var(--color-infobox);}
  &>:nth-child(2){background-color: #FFFFFF;}
  &>:nth-child(3){background-color: #FFFFFF;}
}
.vc-day {
  width: 110px;
  height: 120px;
}
.weekday-1 > div > span, .weekday-7 > div > span {
  color: var(--color-confirm);
  font-weight: 700;
}
.is-today {
  background-color: var(--color-infobox);
}
.vc-container {
  border: none;
}
.vc-title {
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 27px;
  /* identical to box height, or 112% */
  text-align: center;
  letter-spacing: 0.1em;
  color: var(--color-checked)!important;
}
.vc-arrows-container {
  padding-inline: calc((100% - 200px) / 2);
  .vc-svg-icon {
    color: var(--color-checked);
  }
}
.vc-header {
  padding-inline: 120px!important;
}
.vc-weekday {
  &:nth-child(1) {
    border-radius: 5px 0 0 0;
  }
  &:nth-child(7) {
    border-radius: 0 5px 0 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  background-color: var(--color-checked);
  font-family: 'Noto Sans TC'!important;
  font-style: normal!important;
  font-weight: 500!important;
  font-size: 24px!important;
  text-align: center!important;
  letter-spacing: 0.1em!important;
  color: #FFFFFF!important;
}
.on-top {
  border-top: 1px solid var(--color-border);
}
.weekday-1,
.weekday-2,
.weekday-3,
.weekday-4,
.weekday-5,
.weekday-6 {
  border-bottom: 1px solid var(--color-border);
  border-left: 1px solid var(--color-border);
}
.weekday-7 {
  border-bottom: 1px solid var(--color-border);
  border-left: 1px solid var(--color-border);
  border-right: 1px solid var(--color-border);
}
</style>
<style lang="scss" scoped>
.inputinfo {

}
.title {
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  text-align: start;
  margin-bottom: 20px;
}
.hrdeco {
  height: 12px;
  width: 100%;
  background-color: var(--color-pri);
  mask-image: url(/hrdeco.svg);
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  border: none;
  margin-block: 20px;
}
.table {
  display: flex;
  margin-inline: 30px;
  gap: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.tr {
  display: grid;
  height: 40px!important;
  grid-template-columns: 100px 71px 71px;
  gap: 20px;
  .td {
    display: table-cell;
    height: 40px!important;
    box-sizing: border-box;
    &:nth-child(1)>div {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: var(--color-checked);
      width: 100px;
      height: 40px;
      border: 1.5px solid var(--color-checked);
      box-sizing: border-box;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:nth-child(2) >div, &:nth-child(3)>div {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      letter-spacing: 0.1em;
      color: #FFFFFF;
      width: 71px;
      height: 40px;
      background-color: #DADADA;
      box-sizing: border-box;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:nth-child(2) >div.selected {
      background-color: var(--color-tab);
    }
    &:nth-child(3) >div.selected {
      background-color: var(--color-confirm);
    }
  }
}
.tr2 {
  display: grid;
  height: 40px!important;
  grid-template-columns: 100px 71px 71px;
  gap: 20px;
  border-bottom: 1.5px solid var(--color-checked);
  .td {
    display: table-cell;
    height: 40px!important;
    box-sizing: border-box;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    letter-spacing: 0.1em;
    &:nth-child(1)>div {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: var(--color-checked);
      width: 100px;
      height: 40px;
      // border: 1.5px solid var(--color-checked);
      box-sizing: border-box;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:nth-child(2) >div, &:nth-child(3)>div {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      letter-spacing: 0.1em;
      width: 71px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:nth-child(2)>div::before {
      content: '大';
      font-size: 16px;
      margin-right: 6px;
    }
    &:nth-child(3)>div::before {
      content: '孩';
      font-size: 16px;
      margin-right: 6px;
    }
  }
}
.contentSelected {
  color: var(--color-letter);
  z-index: 5;
  position: relative;
  padding: 16px;
  padding-top: 35px;
  .alldisabled {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 282px;
    margin: auto;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-letter);

  }
  input[type=checkbox] {
    appearance: none;
    width: 39px;
    height: 20px;
    border-radius: 10px;
    position: relative;
    background-color: #85CA9E;
    &:checked {
      background-color: #E37878;
    }
    &::before {
      content: '';
      display: inline-flex;
      width: 16px;
      height: 16px;
      position: absolute;
      right: 2px;
      top: 2px;
      background-color: #FFFFFF;
      border-radius: 8px;
    }
    &:checked::before {
      left: 2px;
    }
  }
}
.datetime {
  width: 100%;
  color: var(--color-checked);
  position: relative;
  z-index: 5;
  padding-top: 47px;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: 0.1em;
}
.icon {
  width: 71px;
  height: 71px;
  background-image: url(/celender.svg);
  border-radius: 50%;
  background-color: var(--color-checked);
  z-index: 5;
  position: absolute;
  top: -35.5px;
  left: 50%;
  transform: translateX(-50%);
}
.daily {
  position: relative;
  z-index: 1;
}
.dailyStatus2 {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 45px;
  width: 350px;
  height: calc(100% - 45px);
  border-radius: 10px;
  background-color: transparent;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    display: inline-flex;
    position: absolute;
    top: -45px;
    left: 50%;
    background-color: transparent;
    z-index: -1;
    transform: translateX(-50%);
    border-radius: 50%;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
.dailyStatus {
  z-index: 3;
  margin-top: 45px;
  width: 350px;
  height: calc(100% - 45px);
  z-index: 3;
  position: relative;
  border-radius: 10px;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    display: inline-flex;
    position: absolute;
    top: -45px;
    left: 50%;
    background-color: #FFFFFF;
    z-index: 2;
    transform: translateX(-50%);
    border-radius: 50%;

  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #FFFFFF;
    border-radius: 10px;
  }
}
.dayCube {
  margin: 0;
  min-height: 120px;
  width: 110px;
  box-sizing: border-box;
  &>.is-holiday {
    color: var(--color-confirm);
    font-weight: 700;
  }
  &.disabled {
    background-color: #E5E5E5;
  }
  &.selected {
    border: 2px solid var(--color-checked);
  }
  &.pass {
    filter: contrast(.5);
    background-color: #DADADA33;
  }
  p {
    display: flex;
    align-items: center;
    margin: 0;
    justify-content: flex-start;
  }
}
.babybooktimeset {
  display: grid;
  grid-template-columns: 604px 604px 1fr;
  &>div{
    padding: 25px 37px;
    box-sizing: border-box;
    overflow-y: auto;
    height: calc(100vh - 90px);
    &:nth-child(2) {
      border-left: 1px solid var(--color-border);
    }
    &:nth-child(3) {
      border-left: 1px solid var(--color-border);
    }
  }
}
</style>
